<template>
    <v-container fluid class="invoice_container container-full-bg-white">

        <!-- Componentes emergentes -->

        <v-snackbar v-if="screen_data" v-model="screen_data.snackbar.isVisible" :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout">
            {{ screen_data.snackbar.text }}
        </v-snackbar>


        <v-dialog v-if="screen_data" v-model="screen_data.excelPopup" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="text-h6 primary__blue">Subir excel líneas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="px-7">
                        <v-row>
                            <v-col align="center" class="pa-0">
                                <v-icon color="primary_blue" size="55" class="material-symbols-outlined"> table_chart
                                </v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pt-0" align="center">
                                <span class="text-h6 primary__blue">Orden Cabecera</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="center">
                                <p class="mb-0">Necesitamos la siguiente estructura</p>
                                <p class="font-weight-bold">Descripción / Precio unitario / Cantidad / Tipo
                                    <span v-if="screen_data.recurringInvoice && screen_data.recurringInvoice.invoice && screen_data.recurringInvoice.invoice.tax_type"> {{screen_data.recurringInvoice.invoice.tax_type.toUpperCase()}}</span> *
                                </p>
                                <div class="d-flex flex-column align-center text-center mt-2" role="note">
                                    <div class="d-flex align-center">
                                        <span id="excel-tax-help" class="grey--text text--darken-1 caption mr-1">
                                            Indicaciones: use valor numérico (ej. 0.10), no el porcentaje
                                        </span>
                                        <v-tooltip bottom open-on-hover open-on-click>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    small
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    aria-label="Información sobre tipos de impuesto"
                                                    :aria-describedby="'excel-tax-help excel-optional-note'">
                                                    <v-icon color="primary_blue">mdi-information-outline</v-icon>
                                                </v-btn>
                                            </template>

                                            <div style="max-width: 320px;">
                                                <p class="font-weight-bold mb-2">Ej.: 10% → escriba 0.10</p>

                                                <!-- IVA -->
                                                <template v-if="!screen_data.recurringInvoice || !screen_data.recurringInvoice.invoice || screen_data.recurringInvoice.invoice.tax_type !== 'igic'">
                                                    <p class="subtitle-2 mb-1">Valores IVA:</p>
                                                    <v-simple-table dense>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">Descripción</th>
                                                                <th class="text-left">Valor numérico</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr><td>0%</td>          <td class="font-weight-bold">0.00</td></tr>
                                                            <tr><td>4%</td>          <td class="font-weight-bold">0.04</td></tr>
                                                            <tr><td>5%</td>          <td class="font-weight-bold">0.05</td></tr>
                                                            <tr><td>10%</td>         <td class="font-weight-bold">0.10</td></tr>
                                                            <tr><td>21%</td>         <td class="font-weight-bold">0.21</td></tr>
                                                            <tr><td>4% RE 0.5%</td>  <td class="font-weight-bold">0.005</td></tr>
                                                            <tr><td>10% RE 1.4%</td> <td class="font-weight-bold">0.014</td></tr>
                                                            <tr><td>21% RE 5.2%</td> <td class="font-weight-bold">0.052</td></tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </template>

                                                <!-- IGIC -->
                                                <template v-else>
                                                    <p class="subtitle-2 mb-1">Valores IGIC:</p>
                                                    <v-simple-table dense>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">Descripción</th>
                                                                <th class="text-left">Valor numérico</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr><td>0%</td>  <td class="font-weight-bold">0.00</td></tr>
                                                            <tr><td>3%</td>  <td class="font-weight-bold">0.03</td></tr>
                                                            <tr><td>5%</td>  <td class="font-weight-bold">0.05</td></tr>
                                                            <tr><td>7%</td>  <td class="font-weight-bold">0.07</td></tr>
                                                            <tr><td>15%</td> <td class="font-weight-bold">0.15</td></tr>
                                                            <tr><td>20%</td> <td class="font-weight-bold">0.20</td></tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </template>
                                            </div>
                                        </v-tooltip>
                                    </div>

                                    <div id="excel-optional-note" class="grey--text text--darken-1 caption mt-1" aria-live="off">
                                        Nota: los campos marcados con <strong>*</strong> son opcionales.
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-file-input class="rounded-lg" label="Archivo" v-model="screen_data.file"
                                    prepend-icon="mdi-paperclip" color="primary" accept=" .xls, .xlsx, .xlsm, .ods"
                                    :clearable="false" :loading="false" :rules="[v => !!v || 'Archivo requerido']"
                                    :error="error_upload_file" outlined></v-file-input>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.cancelPopup()" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="screen_data.confirmPopup()"
                        :disabled="!screen_data.file">
                        Subir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-if="screen_data" v-model="screen_data.deleteAllLinesPopup" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="primary__blue">Eliminar Lineas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <span class="mt-2 text-subtitle-1">¿Está seguro que desea eliminar todas las líneas?</span>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.cancelPopup()" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="screen_data.confirmPopup()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="screen_data" v-model="screen_data.realtedInvoicesPopup" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="primary__blue">Registro de facturas creadas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>                        
                        <v-data-table
                            :headers="screen_data.realtedInvoicesHeaders"
                            :items="screen_data.relatedInvoices"
                            class="elevation-1 mb-6" style="min-width: 100%;"
                            hide-default-footer
                            :no-data-text="'No se han encontrado registros'" 
                        >
                            <template v-slot:item.id="{ item }">
                                <v-btn text @click="openInvoiceEditor(item.id)" class="text-decoration-underline font-weight-bold" style="color: var(--v-primary-base);">
                                    {{ item.id }}
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.startDialog" persistent max-width="500" v-if="screen_data.recurringInvoice">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Activar contrato</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p>Esta acción marcará el contrato como activo y se crearán las facturas correspondientes.</p>
                    <p class="my-0">¿Desea continuar?</p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="previewStartDialog(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="startContract()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.stopDialog" persistent max-width="500" v-if="screen_data.recurringInvoice">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Detener contrato</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p>Esta acción marcará el el contrato como detenido y no se crearan más facturas. Esta acción es irreversible</p>
                    <p class="my-0">¿Desea continuar?</p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="previewStopDialog(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="stopContract()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorsDialog" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Atención</span>
                    <v-btn icon @click="screen_data.setErrorDialog(false)">
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Información incompleta</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span>Por favor, <strong>revise los campos pendientes</strong> y complete la información
                                necesaria para poder firmar la factura.</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorsDialogSupplier" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Atención</span>
                    <v-btn icon @click="screen_data.setErrorDialogSupplier(false)">
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Información incompleta {{screen_data.showErrorsDialogSupplier}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span>
                                Para poder activar un contrato, es necesario que el <strong>emisor</strong> tenga todos los datos
                                necesarios. Para completar la información, por favor, diríjase a la sección de
                                <strong>configuración de la empresa</strong> o a cualquier <strong>factura electrónica</strong> de la empresa.
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorExcelDialog" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Atención</span>
                    <v-btn icon @click="screen_data.setErrorExcelDialog(false)">
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Error en la carga del excel</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span>{{ screen_data.error_excel_message }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>


        <!-- Inicio pantalla -->
        <template v-if="screen_data.recurringInvoice">
            <!-- Cabecera -->
            <v-row 
                :class="{
                    'mx-1': is_mobile,
                    'mx-2': !is_mobile,
                    'pa-0': true
                }" 
            >
                <v-col cols="3">
                    <div class="mr-0 d-flex align-center">
                        <v-btn v-if="companydb_id" icon
                            @click="backToList()">
                            <AppIcon :src="require('../../../assets/back-arrow.svg')" :size="29" />
                        </v-btn>
                        <h3 class="primary_blue--text ml-1" v-if="is_tablet">Editor</h3>
                        <h3 class="primary_blue--text ml-2 " v-else>Editor de servicio recurrente</h3>
                    </div>
                </v-col>
                <v-spacer/>
                <v-col cols="3">
                    <template v-if="screen_data && !screen_data.loading">
                        <div class="d-flex justify-space-between px-2 mx-2 my-1 py-0 flex-grow-1" v-if="screen_data.recurringInvoice && is_mobile">
                            <div class="d-flex align-center rounded-pill grey lighten-2 px-2 py-1 flex-grow-1">
                              <p class="ma-0 pa-0">{{ stateTranslator(screen_data.recurringInvoice.state) }}</p>
                              <v-icon :color="getStateIndicatorClass()" dense class="ml-2" small>mdi-circle</v-icon>
                            </div>
                          </div>
                        <div class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center flex-sm-nowrap invoice_state"
                            v-else-if="screen_data.recurringInvoice">
                            <div class="text--grey--darken-3 mr-2 pl-4 font-weight-medium" v-if="!is_mobile">Estado:
                            </div>
                            <div
                                class="d-flex justify-space-between rounded-pill white px-2 mx-2 my-1 py-0 flex-grow-1">
                                <p class="ma-0 pa-0">{{ stateTranslator(screen_data.recurringInvoice.state) }} </p>
                                <v-icon :color="getStateIndicatorClass()" dense small>mdi-circle</v-icon>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <v-progress-circular indeterminate class="mr-2" color="primary"></v-progress-circular>
                    </template>
                </v-col>
                <v-spacer/>
                <template v-if="screen_data && screen_data.recurringInvoice && !is_mobile">
                    <v-col cols="3" class="d-flex justify-end">
                        <v-tooltip bottom v-if="screen_data.recurringInvoice.state != 'not_started' && recurring_invoice_id">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-1"
                                    icon
                                    @click="getRelatedInvoices()"
                                    v-bind="attrs"
                                    :loading="screen_data.loadingRelatedInvoices"
                                    v-on="on">
                                    <AppIcon :src="require('../../../assets/created_invoices.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Registro</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="editable && screen_data.recurringInvoice.state == 'not_started' && recurring_invoice_id">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-1"
                                    icon
                                    @click="previewStartDialog(true)"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="!screen_data.hasActiveContract"
                                >
                                    <AppIcon :src="require('../../../assets/start_contract.svg')" :size="29" :colorMap="{ '060647': !screen_data.hasActiveContract ? 'primary_gray' : 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Comenzar contrato</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="screen_data.recurringInvoice.state == 'started' && recurring_invoice_id">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-1"
                                    icon
                                    @click="previewStopDialog(true)"
                                    v-bind="attrs"
                                    v-on="on">
                                    <AppIcon :src="require('../../../assets/stop_contract.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Detener contrato</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="ml-1" icon @click="saveInvoice()"
                                    :disabled="cantSave" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('../../../assets/save_invoice_disabled.svg')" :size="29" v-if="cantSave" :colorMap="{ '060647': 'primary_blue' }"/>
                                    <AppIcon :src="require('../../../assets/save_invoice.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Guardar</span>
                        </v-tooltip>
                    </v-col>
                </template>
                <v-col v-else-if="screen_data && screen_data.recurringInvoice && is_mobile" cols="2" class="d-flex justify-center">
                    <div id="menu-anchor">
                        <v-menu
                            v-model="speedDial"
                            bottom
                            transition="scale-transition"
                            offset-y
                            content-class="transparent-menu"
                            attach="#menu-anchor"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('../../../assets/btn-show-menu.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }" />
                                </v-btn>
                            </template>

                            <v-list class="transparent-list justify-cente">
                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left v-if="screen_data.recurringInvoice.state != 'not_started' && recurring_invoice_id">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                class="ml-1"
                                                icon
                                                @click="getRelatedInvoices()"
                                                v-bind="attrs"
                                                :loading="screen_data.loadingRelatedInvoices"
                                                v-on="on">
                                                <AppIcon :src="require('../../../assets/created_invoices.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                            </v-btn>
                                        </template>
                                        <span>Registro</span>
                                    </v-tooltip>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left v-if="editable && screen_data.recurringInvoice.state == 'not_started' && recurring_invoice_id">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                class="ml-1"
                                                icon
                                                @click="previewStartDialog(true)"
                                                v-bind="attrs"
                                                v-on="on"
                                                :disabled="!screen_data.hasActiveContract"
                                            >
                                                <AppIcon :src="require('../../../assets/start_contract.svg')" :size="29" :colorMap="{ '060647': !screen_data.hasActiveContract ? 'primary_gray' : 'primary_blue' }"/>
                                            </v-btn>
                                        </template>
                                        <span>Comenzar contrato</span>
                                    </v-tooltip>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left v-if="screen_data.recurringInvoice.state == 'started' && recurring_invoice_id">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                class="ml-1"
                                                icon
                                                @click="previewStopDialog(true)"
                                                v-bind="attrs"
                                                v-on="on">
                                                <AppIcon :src="require('../../../assets/stop_contract.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                            </v-btn>
                                        </template>
                                        <span>Detener contrato</span>
                                    </v-tooltip>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="ml-1" icon @click="saveInvoice()"
                                                :disabled="cantSave" v-bind="attrs" v-on="on">
                                                <AppIcon :src="require('../../../assets/save_invoice_disabled.svg')" :size="29" v-if="cantSave" :colorMap="{ '060647': 'primary_blue' }"/>
                                                <AppIcon :src="require('../../../assets/save_invoice.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                            </v-btn>
                                        </template>
                                        <span>Guardar</span>
                                    </v-tooltip>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </v-col>
                <template v-else>
                    <v-progress-circular indeterminate class="mr-2" color="primary"/>
                </template>
            </v-row>

            <v-card class="sector-div">
                <v-row :class="{'ma-0': true, 'flex-sm-nowrap': !is_tablet }">
                    <v-col cols="12" md="12" lg="4" class="px-0 py-0">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Receptor
                                    <span v-if="(screen_data.recurringInvoice &&
                                                screen_data.recurringInvoice.invoice &&
                                                screen_data.recurringInvoice.invoice.customer &&
                                                customerLabel)">
                                        - {{ customerLabel }}
                                    </span>
                                </p>
                            </v-col>
                        </v-row>
                        <div :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <PartyEditor
                                v-if="this.editorMounted" 
                                title="" 
                                :party="screen_data.recurringInvoice.invoice.customer"
                                :readonly="!editable"
                                :emisor="false" 
                                @update_party="autocompleteCustomer"
                                :partyOptions="screen_data.customers" 
                                :showErrors="screen_data.showErrors"
                                @saveThird="saveThird"
                                :invoiceable_repo="invoiceable_repo"
                                :company_id="companydb_id"
                            />
                        </div>
                    </v-col>
                    <v-divider vertical :class="{'pb-4': !is_mobile}"></v-divider>
                    <v-col cols="12" md="12" lg="4" class="px-0 py-0">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Datos </p>
                            </v-col>
                        </v-row>
                        <div  :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <div>
                                <v-row>
                                    <v-col cols="4" md="12" lg="4" sm="12" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <label class="mr-1 input-label">Serie</label>
                                        <v-select 
                                            :items="screen_data.availableSequences"
                                            item-value="id"
                                            item-text="code"
                                            v-model="screen_data.recurringInvoice.invoice.sequence_id"
                                            @change="sequenceChanged"
                                            :disabled="!editable"
                                            outlined
                                            dense
                                            hide-details
                                            :style="{ backgroundColor: editable ? 'white' : '' }"
                                            :background-color="screen_data.showErrors && !screen_data.recurringInvoice.invoice.sequence_id ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.recurringInvoice.invoice.sequence_id"
                                            >
                                        </v-select>
                                    </v-col>
                                    <v-col cols="4" md="12" lg="4" sm="12" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <label class="mr-1 input-label">Intervalo</label>
                                        <v-select 
                                            :items="screen_data.intervalOptions"
                                            v-model="screen_data.recurringInvoice.interval"
                                            outlined
                                            dense
                                            hide-details
                                            :style="{ backgroundColor: editable ? 'white' : '' }"
                                            :background-color="screen_data.showErrors && !screen_data.recurringInvoice.interval ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.recurringInvoice.interval"
                                            :disabled="!editable"
                                            @change="nextInvoiceInfoChanged()"
                                            >
                                        </v-select>
                                    </v-col>
                                    <v-col cols="4" md="12" lg="4" sm="12" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <label class="mr-1 input-label">Gestión de periodos</label>
                                        <v-select 
                                            :items="screen_data.periodOptions"
                                            v-model="screen_data.recurringInvoice.period"
                                            outlined
                                            dense
                                            hide-details
                                            :style="{ backgroundColor: editable ? 'white' : '' }"
                                            :background-color="screen_data.showErrors && !screen_data.recurringInvoice.period ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.recurringInvoice.period"
                                            :disabled="!editable"
                                            >
                                        </v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4" md="12" lg="4" sm="12" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <AppDateField
                                            ref="invoiceStartDate"
                                            :label="is_tablet ? 'F. inicio' : 'Fecha inicio'"
                                            v-model="screen_data.recurringInvoice.start_date"
                                            :disabled="!editable"
                                            :error="screen_data.showErrors && !screen_data.recurringInvoice.start_date"
                                            :background_color="screen_data.showErrors && !screen_data.recurringInvoice.start_date ? '#DC0B0B1A' : 'white'"
                                            @input="nextInvoiceInfoChanged()"
                                        />
                                    </v-col>
                                    <v-col cols="4" md="12" lg="4" sm="12" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <AppDateField
                                            ref="invoiceEndDate"
                                            :label="is_tablet ?  'F. final' : 'Fecha final'"
                                            v-model="screen_data.recurringInvoice.end_date" 
                                            :disabled="!editable"
                                        />
                                    </v-col>
                                    <v-col cols="4" md="12" lg="4" sm="12" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <label class="mr-1 input-label">Vencimiento</label>
                                        <v-select 
                                            :items="screen_data.expirationOptions"
                                            v-model="screen_data.recurringInvoice.expiration"
                                            outlined
                                            dense
                                            hide-details
                                            :style="{ backgroundColor: editable ? 'white' : '' }"
                                            :background-color="screen_data.showErrors && ![0, 30, 60, 90].includes(screen_data.recurringInvoice.expiration) ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && ![0, 30, 60, 90].includes(screen_data.recurringInvoice.expiration)"
                                            :disabled="!editable"
                                            >
                                        </v-select>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                    <v-divider vertical class="pb-4"></v-divider>
                    <v-col cols="6" md="12" lg="2" sm="12" class="px-0 py-0">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Próxima Factura </p>
                            </v-col>
                        </v-row>
                        <div :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <v-row class="align-center">
                                <v-col class="pr-0">
                                    <span class="input-label font-weight-medium">Intervalo</span>
                                </v-col>
                                <v-col class="pl-0">
                                    <v-chip
                                      class="text-capitalize font-weight-medium w-100 d-flex justify-center no-hover"
                                      color="grey lighten-3"
                                      label
                                    >
                                      {{ screen_data.recurringInvoice.interval }}
                                    </v-chip>

                                </v-col>
                            </v-row>

                            <v-row class="align-center mt-2">
                                <v-col class="pr-0">
                                    <span class="input-label font-weight-medium">Fecha inicio</span>
                                </v-col>
                                <v-col class="pl-0">
                                    <v-chip
                                      class="text-uppercase font-weight-medium w-100 d-flex justify-center no-hover"
                                      color="grey lighten-3"
                                      label
                                    >
                                      {{ formattedDate(screen_data.nextInvoiceInfo.start_date) }}
                                    </v-chip>
                                </v-col>
                            </v-row>

                            <v-row class="align-center mt-2">
                                <v-col class="pr-0">
                                    <span class="input-label font-weight-medium">Fecha final</span>
                                </v-col>
                                <v-col class="pl-0">
                                    <v-chip
                                      class="text-uppercase font-weight-medium w-100 d-flex justify-center no-hover"
                                      color="grey lighten-3"
                                      label
                                    >
                                      {{ formattedDate(screen_data.nextInvoiceInfo.end_date) }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </div> 
                    </v-col>
                    <v-divider vertical class="pb-4"></v-divider>
                    <v-col  cols="6" md="12" lg="2" sm="12" class="px-0 py-0">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Emitir y enviar automático </p>
                            </v-col>
                        </v-row>
                        <div :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <div class="d-flex align-center justify-space-between mt-1">
                              <span class="input-label font-weight-medium">Emitir las facturas auto.</span>
                              <v-switch
                                v-model="screen_data.recurringInvoice.create_auto"
                                :disabled="!editable"
                                color="primary_blue"
                                inset
                                hide-details
                                class="switch__space"
                                @change="onCreateAutoChange"
                              />
                            </div>
                            
                            <div class="d-flex align-center justify-space-between mt-4">
                              <span class="input-label font-weight-medium">Enviar las facturas auto.</span>
                              <v-switch
                                v-model="screen_data.recurringInvoice.send_auto"
                                :disabled="!screen_data.recurringInvoice.create_auto || !editable"
                                color="primary_blue"
                                inset
                                hide-details
                                class="switch__space"
                              />
                            </div>
                          </div>                          
                    </v-col>
                </v-row>
            </v-card>
            <!-- {{ screen_data.invoice }} -->
            <v-card class="sector-div" v-if="screen_data.recurringInvoice">
                <InvoiceLinesEditor :invoice_lines="screen_data.recurringInvoice.invoice.lines"
                    :invoice="screen_data.recurringInvoice.invoice" @delete-line="deleteLine" @delete-all-lines="deleteAllLines"
                    @change-line="invoiceLineChanged" @add-line="addLine" @import-lines="importLines"
                    @change-additional-info="invoiceAditionalInfoChanged" :allow_import="editable"
                    :loading="screen_data.loading" :readonly="!editable" style="padding-top:0;"
                    :products="screen_data.products" :showErrors="screen_data.showErrors"
                    :tax_type="screen_data.recurringInvoice.invoice.tax_type?screen_data.recurringInvoice.invoice.tax_type:'iva'"
                    :isRecurringContract="true"
                    :productConfiguration="screen_data.productConfiguration">
                </InvoiceLinesEditor>
                <v-row>
                    <v-col cols="5" >
                        <div style="padding: 0 16px;margin-top:16px">
                            
                            <v-textarea outlined label="Observaciones" v-model="screen_data.recurringInvoice.invoice.additional_info" :readonly="!editable">
                            </v-textarea>
                        </div>
                    </v-col>
                    <v-col cols="7">
                        
                        <InvoiceTotalsViewer :invoice="screen_data.recurringInvoice.invoice" :readonly="true"/>
                    </v-col>
                </v-row>
                <v-spacer/>
                
                
            </v-card>

            <v-card v-if="!is_mobile" class="sector-div">
                <v-row :class="{'ma-0': true, 'flex-sm-nowrap': !is_tablet }">
                    <v-col cols="12"  class="px-0 py-0">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Otros campos </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                <div style="padding: 0 20px;margin-top:16px">
                                    <label class="input-label">Método de pago</label>
                                    <v-select
                                        :readonly="!editable"
                                        :items="screen_data.payment_options"
                                        item-value="value"
                                        item-text="text"
                                        outlined
                                        dense
                                        hide-details
                                        v-model="screen_data.recurringInvoice.invoice.payment_means"
                                        @change="onPaymentMeansChange"
                                        :error="screen_data.showErrors && screen_data.recurringInvoice.invoice.payment_means == '00'"
                                        :background-color="screen_data.showErrors && screen_data.recurringInvoice.invoice.payment_means == '00' ? '#DC0B0B1A' : ''"
                                    ></v-select>
                                </div>
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col cols="5" >
                                <div style="padding: 0 16px;margin-top:16px">
                                    
                                    <v-textarea outlined label="Notas internas" v-model="screen_data.recurringInvoice.invoice.free_notes" @input="dirtyFreeNotes=true">
                                    </v-textarea>
                                </div>
                            </v-col>
                        </v-row> -->
                    </v-col>
                </v-row>
            </v-card>

            <!-- card formato movil -->
            <v-card v-if="is_mobile" class="sector-div pb-8">
                <v-row class="ma-0">
                    <v-col cols="12" :class="['px-0 py-0', {'sector-head--mobile' : is_mobile}]">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                            <p class="mb-0">Otros campos</p>
                            </v-col>
                        </v-row>

                        <v-row dense class="px-4 mt-2" align="start">
                            <v-col
                            cols="12"
                            md="6"
                            >
                            <v-select
                                :readonly="!editable"
                                :items="screen_data.payment_options"
                                label="Selecciona un método de pago"
                                item-value="value"
                                item-text="text"
                                v-model="screen_data.recurringInvoice.invoice.payment_means"
                                @change="onPaymentMeansChange"
                                :error="screen_data.showErrors && screen_data.recurringInvoice.invoice.payment_means == '00'"
                                :background-color="screen_data.showErrors && screen_data.recurringInvoice.invoice.payment_means == '00' ? '#DC0B0B1A' : ''"
                            />
                            </v-col>

                            <!-- <v-col cols="12" md="6">
                                <v-textarea
                                    outlined
                                    label="Notas internas"
                                    v-model="screen_data.invoice.free_notes"
                                    @input="dirtyFreeNotes = true"
                                    auto-grow
                                    hide-details
                                />
                            </v-col> -->
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>

        </template>
    </v-container>
</template>

<script>
import InvoiceTotalsViewer from "@/components/InvoiceTotalsViewer.vue"
import InvoiceLinesEditor from "@/components/InvoiceLinesEditor.vue"
import PartyEditor from "@/components/PartyEditor.vue"
import { ApiInvoiceableRepository } from './ApiInvoiceableRepository'
import { ApiProductRepository, ApiProductConfigurationRepository } from "./ApiProductRepository";
import { mapState, mapGetters } from 'vuex'
import awsconfig from '../../../aws-exports';
import { S3Repository } from '../../shared/infra/S3Repository'
import AppDateField from "@/modules/widgets/infra/AppDateField.vue";
import { ApiConfigurationRepository } from "./ApiConfigurationRepository";
import { VueRecurringInvoiceEditorScreenData } from "./VueRecurringInvoiceEditorScreenData";
import { ApiRecurringInvoiceRepository } from "./ApiRecurringInvoiceRepository";
import { RecurringInvoiceEditorComponent } from "../app/RecurringInvoiceEditorComponent";

export default {
    components: {
        InvoiceLinesEditor,
        PartyEditor,
        InvoiceTotalsViewer,
        AppDateField,
    },
    props: {
        recurring_invoice_id: {
            type: [Number, String],
            required: false,
            default: null
        },
        companydb_id: {
            type: [Number, String],
            required: false,
            default: null
        }
    },
    data() {
        const screen_data = new VueRecurringInvoiceEditorScreenData();
        return {
            screen_data: screen_data,
            recurring_invoice_editor_component: null,
            error_upload_file: false,
            dirtyFreeNotes: false,
            speedDial: false,
            invoiceable_repo: null,
            editorMounted: false,
        }
    },
    watch: {
        companydb_id: function (newVal, oldVal) {
            this.$router.push({ 'name': 'recurring-invoice-list', 'params': { 'companydb_id': newVal } })
        }
    },
    async mounted() {
        this.creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        this.creds.params.Logins = this.creds.params.Logins || {};
        this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] = this.session_information.signInUserSession.idToken.jwtToken;
        this.creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: this.creds,
        });
        let s3_repo = new S3Repository(AWS, 'excel_lines')
        let product_repo = new ApiProductRepository()
        let config_repo = new ApiConfigurationRepository()
        this.invoiceable_repo = new ApiInvoiceableRepository()
        let product_config_repo = new ApiProductConfigurationRepository()
        let recurring_invoice_repo = new ApiRecurringInvoiceRepository()
        this.recurring_invoice_editor_component = new RecurringInvoiceEditorComponent(recurring_invoice_repo,
                                                                                      this.invoiceable_repo,
                                                                                      product_repo,
                                                                                      config_repo,
                                                                                      s3_repo,
                                                                                      this.screen_data,
                                                                                      this.currentCompany,
                                                                                      product_config_repo)
        let correctMount = await this.recurring_invoice_editor_component.mountEditor(this.recurring_invoice_id,
                                                                                     this.companydb_id)
        // esto ya no hace falta porque he desactivado los botones que requieren de tener contrato de factura electrónica (si ves esto, borralo :) ) 
        // if (!correctMount) {
        //     this.backToList();
        // }
        this.editorMounted = true
    },
    methods: {
        invoiceAditionalInfoChanged() {
            console.log("InvoiceAditionalInfoChanged")
            this.recurring_invoice_editor_component.updateInvoice()
        },
        invoiceLineChanged(i) {
            console.log("InvoiceLineChanged")
            console.log(i)
            this.recurring_invoice_editor_component.updateInvoiceLine(i)
            this.recurring_invoice_editor_component.updateInvoice()
        },
        addLine() {
            console.log("LinesAmountChanged")
            this.recurring_invoice_editor_component.addLine()
        },
        deleteLine(i) {
            console.log("DeleteLine")
            this.recurring_invoice_editor_component.deleteLine(i)
            this.recurring_invoice_editor_component.updateInvoice()
        },
        deleteAllLines() {
            console.log("DeleteAllLines")
            this.recurring_invoice_editor_component.deleteAllLines()
        },
        importLines() {
            console.log("ImportLines")
            this.recurring_invoice_editor_component.importExcelLines()
        },
        async saveInvoice() {
            console.log("saveInvoice")
            await this.recurring_invoice_editor_component.saveRecurringInvoice()
            this.$router.replace({ name: 'recurring-invoice-editor', params: { 'companydb_id': this.companydb_id, 'recurring_invoice_id': this.screen_data.recurringInvoice.id } });
        },
        formattedDate(date) {
            return date ? new Date(date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }) : '-';
        },
        handleDateChange(dateField, menuVisibility) {
            this[menuVisibility] = false;
            return (value) => {
                this.screen_data.recurringInvoice[dateField] = value;
            };
        },
        isParyIncoplete(party) {
            const isEmpty = (value) => ['', null, undefined].includes(value);
            if (!party || (party && (isEmpty(party.cif) || isEmpty(party.type)
                || (party.type == 'juridica' && isEmpty(party.business_name))
                || (party.type == 'fisica' && (isEmpty(party.name) || isEmpty(party.first_surname)))
                || isEmpty(party.address) || isEmpty(party.city) || isEmpty(party.province) || isEmpty(party.post_code)))) {
                return true
            }
            return false
        },
        isContractIncomplete() {
            const isEmpty = (value) => ['', null, undefined].includes(value);

            function areInvoiceLinesValid(lines, feat_lines_0){
                for (let i=0; i<lines.length; i++){
                    if (!lines[i].iamvalid(feat_lines_0)){
                        return false
                    }
                }
                return true;
            }

            if (
                isEmpty(this.screen_data.recurringInvoice.start_date) ||
                isEmpty(this.screen_data.recurringInvoice.interval) ||
                isEmpty(this.screen_data.recurringInvoice.period) ||
                isEmpty(this.screen_data.recurringInvoice.expiration) ||
                isEmpty(this.screen_data.recurringInvoice.invoice.sequence_id) ||
                this.screen_data.recurringInvoice.invoice.lines.length == 0 ||
                !areInvoiceLinesValid(this.screen_data.recurringInvoice.invoice.lines, this.got_feature('feature_facturae_allow_lines_at_zero')) ||
                this.isParyIncoplete(this.screen_data.recurringInvoice.invoice.customer) ||
                this.screen_data.recurringInvoice.invoice.payment_means == '00'
            ) {
                return true;
            }
            return false;
        },
        autocompleteCustomer(party) {
            this.screen_data.setCustomer(party)
        },
        async saveThird(party) {
            this.screen_data.setPaymentMeans(party.payment_means)
            this.screen_data.setPaymentInformation(party.payment_information)
            const success = await this.recurring_invoice_editor_component.saveThirdParty(party)
            return success
        },
        onPaymentMeansChange(){
            this.screen_data.recurringInvoice.invoice.flag_payment_means_modified = true
        }, 
        backToList() {
            this.$router.push({ name: 'recurring-invoice-list', params: { 'companydb_id': this.companydb_id } });
            return
        },
        previewStartDialog(value) {
            if (value) {
                if (this.isContractIncomplete()) {
                    this.screen_data.showErrors = true
                    this.screen_data.setErrorDialog(true)
                    return
                } 
                if (this.isParyIncoplete(this.screen_data.recurringInvoice.invoice.supplier)) {
                    this.screen_data.showErrors = true
                    this.screen_data.setErrorDialogSupplier(true)
                    return
                }
            }
            this.screen_data.startDialog = value
        },
        previewStopDialog(value) {
            this.screen_data.stopDialog = value
        },
        async startContract() {
            this.previewStartDialog(false)
            await this.recurring_invoice_editor_component.startStopContract(true)
        },
        stopContract() {
            this.previewStopDialog(false)
            this.recurring_invoice_editor_component.startStopContract(false)
        },
        sequenceChanged() {
            this.recurring_invoice_editor_component.sequenceChanged()
        },
        stateTranslator(state) {
            switch (state) {
                case 'not_started':
                    return 'No iniciado';
                case 'started':
                    return 'En curso';
                case 'stopped':
                    return 'Detenido';
                case 'finished':
                    return 'Finalizado';
                default:
                    return state;
            }
        },
        getStateIndicatorClass() {
            if (this.screen_data.recurringInvoice.state === 'not_started') {
                return '#FF8533';
            } else if (['started'].includes(this.screen_data.recurringInvoice.state)) {
                return '#67c767'
            }  else if (['stopped', 'finalized'].includes(this.screen_data.recurringInvoice.state)) {
                return '#d53d3d';
            } else {
                return '#808080'; 
            }
        },
        async nextInvoiceInfoChanged() {
            if (this.recurring_invoice_id) {
                let interval = this.screen_data.recurringInvoice.interval ? this.screen_data.recurringInvoice.interval : 'mensual'
                let start_date = this.screen_data.recurringInvoice.start_date
                await this.recurring_invoice_editor_component.updateNextInvoiceInfo(
                    this.recurring_invoice_id,
                    interval,
                    start_date
                )
            }
        },
        getRelatedInvoices() {
            this.recurring_invoice_editor_component.getRelatedInvoices()
        },
        openInvoiceEditor(id) {
            window.open(this.$router.resolve({ name: 'invoice-editor', params: { 'companydb_id': this.companydb_id, 'invoice_id': id } }).href, '_blank');
        },
        onCreateAutoChange() {
            if (!this.screen_data.recurringInvoice.create_auto) {
                this.screen_data.recurringInvoice.send_auto = false
            }
        }
    },
    computed: {
        ...mapState([
            'session_information',
            'currentCompany'
        ]),
        ...mapGetters({
            got_feature: 'got_feature',
            is_mobile: 'is_mobile',
            screen_size: 'screen_size'
        }),
        customerLabel() {
            const inv = (this.screen_data && this.screen_data.recurringInvoice &&
                        this.screen_data.recurringInvoice.invoice ?
                        this.screen_data.recurringInvoice.invoice : null);
            const c = inv && inv.customer ? inv.customer : null;
            if (!c) return '';
            if (c.type === 'juridica' && c.business_name) {
                return c.business_name;
            }
            if (c.type === 'fisica') {
                const fs = c.first_surname || '';
                const ss = c.second_surname || '';
                const nm = c.name || '';
                const parts = [];
                const surnames = (fs + ' ' + ss).trim();
                if (surnames) parts.push(surnames);
                if (nm) parts.push(nm);
                return parts.length ? parts.join(', ') : '';
            }
            return '';
        },
        cantSave(){
            return !this.editable
        },
        editable() {
            if (!this.screen_data || !this.screen_data.recurringInvoice) {
                return false
            }
            return this.screen_data.recurringInvoice.state == 'not_started'
        },
        is_tablet() {
            let tablet = false;
            if (this.is_mobile || this.screen_size == 'md') {
                tablet = true;
            }
            return tablet;
        },
    },

}
</script>

<style>
.title-color {
    color: var(--v-primary-base);
}

.overflow-hidden {
    overflow-x: hidden;
}

.sector-head {
    padding: 0px;
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    max-height: 50px;
    margin: 0px
}

.right-border {
    border-right: 1px solid #e0e0e0;
}

.sector-div {
    background-color: #f5f5f5;
    padding: 0px;
    min-width: 100% !important;
}

.custom-font .v-input__control .v-input__slot {
    background: rgba(0, 0, 0, 0) !important;
    border-bottom: 0px solid transparent !important;
    border-color: rgba(0, 0, 0, 0) !important;
}

.sector__input .row .col {
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 12px !important;
}

.sector__input {
    padding-top: 10px;
}

.sector__input label {
    font-weight: 500;
}
</style>

<style lang="scss" scoped>
.custom-gray-text>>>.v-input__control .v-input__slot .v-text-field__slot {
    color: gray;
}

.low-size-font >>> input {
    background-color: blue !important;
    color: red !important;
    font-size: 9px !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
}

.state-container {
    display: flex;
    align-items: center;
}

.state-text {
    border: 2px solid gray;
    border-radius: 20px;
    padding: 8px 16px;
    margin-right: 10px;
}

.state-indicator {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.state-indicator--draft {
    background-color: #FF8533;
}

.state-indicator--approved {
    background-color: #67c767;
}

.state-indicator--rejected {
    background-color: #d53d3d;
}

.state-indicator--default {
    background-color: gray;
}

.container-full-bg-white {
    height: 100%;
    background-color: white;
    border-top-left-radius: 15px;
    position: absolute;
    overflow-y: auto;
    padding: 0px;
}

.invoice_container {
    overflow-x: hidden;
}

.invoice_right_viewer .v-dialog.v-dialog--active {
    margin: 0;
}

.invoice_right_viewer {
    position: absolute !important;
    right: 0 !important;
    height: 100vh !important;
    width: 50% !important;
    overflow-y: auto;
    background-color: red !important;
}

.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}

.error__dialog .v-card__title {
    background-color: #DC0B0BE5 !important;
    color: white !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 24px !important;
}

.input-label {
    font-size: 12px !important;
    white-space: nowrap !important;
}

.btn_pointer {
    cursor: pointer;
}
::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}
</style>

<style>
.custom-select>.v-text-field.v-text-field--solo .v-input__control,
.custom-select>.v-text-field.v-text-field--solo .v-select__slot,
.custom-select>.v-text-field.v-text-field--solo .v-input__slot {
    min-height: 5px !important;
    max-height: 25px !important;
    padding: 0px !important;
}

.invoice_right_viewer .v-dialog.v-dialog--active {
    margin: 0;
}

.invoice_right_viewer {
    position: absolute;
    right: 0;
    left: auto;
    height: 100vh;
    width: 50%;
    overflow-y: auto;
    margin: 0;
    max-height: 100% !important;
}

.invoice_center_viewer {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

.invoice_center_viewer_component {
    height: auto !important;
    min-height: auto !important;
    border: 1px solid rgba(86, 86, 86, 0.502);
    max-width: 1200px;
}

.primary__blue {
    color: var(--v-primary_blue-base);
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}

.transparent-menu.v-menu__content {
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
}
  
.transparent-list {
    background-color: transparent !important;
    box-shadow: none !important;
    padding-top: 6px !important;
}

.transparent-list > .v-list-item {
    min-height:32px !important;
    padding-left: 0px !important;
}

.menu-anchor {
    position: relative;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 26px 20px;
}
.no-hover.v-chip {
    pointer-events: none;
    background-color: #e0e0e0 !important;
    color: black !important;
}
.switch__space {
    margin: 0 !important;
}

.invoice_state {
    width: 100% !important;
}
</style>